import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import App from './App';
// import ProtectedRoute from './Components/ProtectedRoute';
// import { useUserContext } from './core/context/user.context';
import { ToBool } from './core/helpers';

// import useTracking from './core/hooks/useTracking';

const Legal = lazy(() => import('./Components/Legal/Legal'));
const LandingApp = lazy(() => import('./LandingApp'));
const Article = lazy(() => import('./Pages/Article/Article'));
const Blog = lazy(() => import('./Pages/Blog/Blog'));
const Case = lazy(() => import('./Pages/Case/Case'));
const CommunityPage = lazy(() => import('./Pages/Community/CommunityPage'));
// const ForgotPassword = lazy(() => import('./Pages/ForgotPassword/ForgotPassword'));
const Home = lazy(() => import('./Pages/Home/Home'));
// const Invite = lazy(() => import('./Pages/Invite/Invite'));
const LandingPage = lazy(() => import('./Pages/LandingPage/LandingPage'));
const Page = lazy(() => import('./Pages/Page/Page'));
const PageNotFound = lazy(() => import('./Pages/PageNotFound/PageNotFound'));
const People = lazy(() => import('./Pages/People/People'));
// const ResetPassword = lazy(() => import('./Pages/ResetPassword/ResetPassword'));
// const AccountEdit = lazy(() => import('./Pages/User/Edit/Edit'));
// const EmailConfirm = lazy(() => import('./Pages/User/EmailConfirm/EmailConfirm'));
// const Login = lazy(() => import('./Pages/User/Login/Login'));
// const Overview = lazy(() => import('./Pages/User/Overview/Overview'));
const AboutUs = lazy(() => import('./Pages/AboutUs/AboutUs'));
// const SecurityPrivacy = lazy(() => import('./Pages/User/SecurityPrivacy/SecurityPrivacy'));

function AppRoutes() {
  // const { user } = useUserContext();
  // const { trackUser } = useTracking();

  // useEffect(() => {
  //   if (!user?.token) return;
  //   trackUser();
  // }, [user?.token, trackUser]);

  return (
    <Suspense>
      <Routes>
        {ToBool(process.env.REACT_APP_SHOW_LANDING_PAGE) ? (
          <Route path="/" element={<LandingApp />}>
            <Route index element={<LandingPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        ) : (
          <>
            <Route path="/" element={<App />}>
              <Route index element={<Home />} />
              {/* <Route path="login" element={<Login />} /> */}
              {/* <Route path="register" element={<Invite />} /> */}
              {/* <Route path="forgot-password" element={<ForgotPassword />} /> */}
              {/* <Route path="email-confirm/:hash" element={<EmailConfirm />} /> */}
              {/* <Route path="resetpassword" element={<ResetPassword />} /> */}
              {/* <Route element={<ProtectedRoute user={user} />}>
                <Route path="user">
                  <Route index element={<Overview />} />
                </Route>
                <Route path="profile-edit" element={<AccountEdit />} />
                <Route path="security-privacy" element={<SecurityPrivacy />} />
              </Route> */}
              <Route path="blog">
                <Route index element={<Blog />} />
                <Route path=":slug" element={<Article />} />
              </Route>
              <Route path="case">
                <Route path=":slug" element={<Case />} />
              </Route>
              <Route path="about-us" element={<AboutUs />} />
              <Route path="community">
                <Route index element={<CommunityPage />} />
                <Route path="people/:slug">
                  <Route index element={<People />} />
                </Route>
              </Route>
              <Route path="terms-and-conditions" element={<Legal type="termsAndConditions" />} />
              <Route path="privacy-policy" element={<Legal type="privacyPolicy" />} />
              <Route path=":parent/:slug" element={<Page />} />
              <Route path=":slug" element={<Page />} />
              <Route path="*" element={<PageNotFound />} />
            </Route>
            <Route path="landing" element={<LandingApp />}>
              <Route index element={<LandingPage />} />
            </Route>
          </>
        )}
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
